import { getApi } from "../api";

/**
 * POST /api/v2/accounts/{account}/shipments/{shipment}/routes — one segment (proxied to gpx-device-api).
 * Body: `from_stop_id`, `to_stop_id`, `corridor_width_meters`, `route_options[]` with `encoded_polyline`,
 * optional `name` (path label), optional `meta`.
 */
export default async function postAccountShipmentRouteSegment(
  accountId: number,
  shipmentId: number,
  segment: Record<string, unknown>,
): Promise<void> {
  const { api, baseURL } = getApi();
  await api.post(
    `/api/v2/accounts/${accountId}/shipments/${shipmentId}/routes`,
    segment,
    { baseURL },
  );
}
